import { connect } from 'react-redux';

import HeaderContent from 'common/components/Header/components/HeaderContent';
import commonMapDispatchToProps from 'common/components/Header/container/headerCommonMapDispatchToProps';

const mapStateToProps = state => ({
  userData: state.get('userData'),
});

export const mapDispatchToProps = dispatch => ({
  ...commonMapDispatchToProps(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderContent);
